module.exports = __webpack_public_path__ + "static/media/icon_image-23.abb0b377.svg";